export const homeData = {
  home_main: {
    title_01_ua: 'Онлайн Школа',
    title_02_ua: 'Іноземних',
    title_03_ua: 'Мов',
    title_01_ru: 'Онлайн Школа',
    title_02_ru: 'Иностранных',
    title_03_ru: 'Языков',
  },
  home_services: {
    ticker: {
      id: 'abra09875',
      ticker_ua: 'Працюємо з мозком - а не з книжками',
      ticker_ru: 'Работаем с мозгом - а не с книжками',
    },
    services: [
      {
        description_ua: 'Онлайн уроки',
        description_ru: 'Онлайн уроки',
        title_ua: 'Англійської мови',
        title_ru: 'Английского языка',
        link: '/services-inner/',
      },
      {
        description_ua: 'Онлайн уроки',
        description_ru: 'Онлайн уроки',
        title_ua: 'Німецької мови',
        title_ru: 'Немецкого языка',
        link: '/services-inner/',
      },
      {
        description_ua: 'Онлайн уроки',
        description_ru: 'Онлайн уроки',
        title_ua: 'Французької мови',
        title_ru: 'Французского языка',
        link: '/services-inner/',
      },
      {
        description_ua: 'Онлайн уроки',
        description_ru: 'Онлайн уроки',
        title_ua: 'Іспанської мови',
        title_ru: 'Испанского языка',
        link: '/services-inner/',
      },
    ],
  },
  home_video: {
    video_ua: 'https://youtu.be/sDeMfL8Ib9A',
    video_ru: 'https://youtu.be/5GbSKaFf8Uc',
    cover: 'cover',
  },
  home_about: {
    ticker: {
      id: 'abra098',
      ticker_ua: 'Задоволення та результат',
      ticker_ru: 'Удовольствие и результат',
    },
    title_ua: 'Про школу \nта підхід',
    title_ru: 'О школе \nи подходе',
  },
  home_advantages: [
    {
      title_ua: 'Контроль прогресу',
      title_ru: 'Контроль прогресса',
      description_ua:
        'Домашнє завдання приносить задоволення і включає мозок. Для нас це поради, статті для журналу, причини глобальних проблем і ще багато різних форматів.',
      description_ru:
        'Вы сами ставите цели для изучения, а мы помогаем вам их достигнуть. Каждые 10-е занятие мы проводим тест по всему, что мы с вами выучили',
    },
    {
      title_ua: "Запам'ятовування",
      title_ru: 'Запоминание',
      description_ua:
        "Перед початком вивчення ми визначаємо тип вашого сприйняття інформації. Працюємо з усіма видами пам'яті.",
      description_ru:
        'Перед началом изучения мы определяем тип вашего восприятия информации. Работаем со всеми видами памяти.',
    },
    {
      title_ua: 'Проста граматика',
      title_ru: 'Простая грамматика',
      description_ua:
        'Допомагаємо понять складну граматику на простих прикладах і застосувати її в життєвих ситуаціях.',
      description_ru:
        'Помогаем понять сложную грамматику на простых примерах и применить ее в жизненных ситуациях.',
    },
    {
      title_ua: 'Мінімум книжок',
      title_ru: 'Минимум книжек',
      description_ua:
        'Ви вчили англійську по книгам 11 років, а може і більше. Тепер ви знову тут. Книги не працюють для розмови. А ми практикуємо живе спілкування.',
      description_ru:
        'Вы учили английский по книгам 11 лет, а может и больше. Теперь вы снова здесь. Книги не работают для разговора. А мы практикуем живое общение.',
    },
    {
      title_ua: 'Розуміння логіки',
      title_ru: 'Понимание логики ',
      description_ua:
        'Англійська стане зрозумілою мовою, адже ми пояснити вам «чому так».',
      description_ru:
        'Английский станет понятным языком, ведь мы объясним вам «почему так»',
    },
    {
      title_ua: 'Креативна домашка',
      title_ru: 'Креативная домашка',
      description_ua:
        'Домашнє завдання приносить задоволення і включає мозок. Для нас це поради, статті для журналу, причини глобальних проблем і ще багато різних форматів.',
      description_ru:
        'Домашнее задание приносит удовольствие и включает мозг. Для нас это советы, статьи для журнала, причины глобальных проблем и еще много разных форматов.',
    },
  ],
  home_steps: {
    step_count: '09',
    title_ua: 'Кроків до вільного спілкування іноземною мовою',
    title_ru: 'Шагов к свободному общению на иностранном языке',
    steps_items: [
      {
        marker_ua: 'Крок 01.',
        marker_ru: 'Шаг 01.',
        title_ua: 'Проводимо пробний урок',
        title_ru: 'Проводим пробный урок',
      },
      {
        marker_ua: 'Крок 02.',
        marker_ru: 'Шаг 02.',
        title_ua: 'Оцінюємо рівень',
        title_ru: 'Оцениваем уровень',
      },
      {
        marker_ua: 'Крок 03.',
        marker_ru: 'Шаг 03.',
        title_ua: 'Складемо необхідну програму',
        title_ru: 'Составим необходимую программу',
      },
      {
        marker_ua: 'Крок 04.',
        marker_ru: 'Шаг 04.',
        title_ua: 'Виправляємо помилки',
        title_ru: 'Исправляем ошибки',
      },
      {
        marker_ua: 'Крок 05.',
        marker_ru: 'Шаг 05.',
        title_ua: 'Обробляємо новий матеріал',
        title_ru: 'Обрабатываем новый материал',
      },
      {
        marker_ua: 'Крок 06.',
        marker_ru: 'Шаг 06.',
        title_ua: 'Тренуємо речення',
        title_ru: 'Тренеруем предложения',
      },
      {
        marker_ua: 'Крок 07.',
        marker_ru: 'Шаг 07.',
        title_ua: 'Говоримо',
        title_ru: 'Говорим',
      },
      {
        marker_ua: 'Крок 08.',
        marker_ru: 'Шаг 08.',
        title_ua: 'Виконуємо креативну домашку',
        title_ru: 'Выполняем креативную домашку',
      },
      {
        marker_ua: 'Крок 09.',
        marker_ru: 'Шаг 09.',
        title_ua: 'Говоримо легко і правильно',
        title_ru: 'Говорим легко и правильно',
      },
    ],
  },
  home_guides: {
    marker_ua: 'Корисні матеріали',
    marker_ru: 'Полезные материалы',
    title_ua: 'Завантажуйте гайд по вимові і говоріть завжди гарно!',
    title_ru: 'Загружайте гайд по произношению и говорите всегда хорошо!',
  },
  home_reviews: {
    title_ua: 'Відгуки наших учнів про школу',
    title_ru: 'Отзывы наших учеников о школе',
  },
  home_free_lesson: {
    title_ua: 'Спробуй вивчати іноземну мову - це просто та цікаво!',
    title_ru: 'Поробуй изучать иностранный язык - это легко и интересно!',
  },
};
